/* eslint-disable(prettier/prettier) */
// 🔴 DO NOT EDIT — This file is generated.

import * as React from 'react'
import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
const BookmarkSavedSvg = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path d="M6 2c-1.156 0-2 .965-2 2v18.04l8-2.974 8 2.973V4c0-.523-.191-1.055-.566-1.43-.38-.379-.91-.57-1.434-.57z" />
  </svg>
)
const ForwardRef = forwardRef(BookmarkSavedSvg)
export default ForwardRef
